/* Size pills on .pv-ord-card (delegated so AJAX-loaded cards work). */
(() => {
  function applyVariantSelection(card, btn) {
    if (!card || !btn) return;

    card.querySelectorAll('[data-pv-ord-size]').forEach((b) => b.classList.toggle('is-selected', b === btn));

    const input = card.querySelector('[data-pv-ord-variant-input]');
    const price = card.querySelector('[data-pv-ord-price]');
    const atc = card.querySelector('[data-pv-ord-atc]');
    const label = card.querySelector('[data-pv-ord-atc-label]');
    const img = card.querySelector('[data-pv-ord-img], .pv-ord-card__img');
    const available = btn.dataset.variantAvailable === 'true';

    if (input) input.value = btn.dataset.variantId;
    if (price && btn.dataset.variantPrice) price.textContent = btn.dataset.variantPrice;
    const compare = card.querySelector('[data-pv-ord-compare]');
    const saleBadge = card.querySelector('[data-pv-ord-sale-badge]');
    const compareVal = btn.dataset.variantCompare || '';
    const salePct = btn.dataset.variantSalePct || '';
    if (compare) {
      compare.hidden = !compareVal;
      compare.textContent = compareVal;
    }
    if (saleBadge) {
      saleBadge.hidden = !salePct;
      saleBadge.textContent = salePct ? `${salePct}% OFF` : '';
    }
    if (atc) atc.disabled = !available;
    if (label) label.textContent = available ? 'add to cart' : 'Sold out';

    const imageUrl = btn.dataset.variantImage;
    const imageSrcset = btn.dataset.variantSrcset;
    if (img && imageUrl) {
      img.src = imageUrl;
      if (imageSrcset) img.srcset = imageSrcset;
      else img.removeAttribute('srcset');
    }
  }

  window.pvOrdApplyVariantSelection = applyVariantSelection;

  if (window.pvOrdCardsBound) return;
  window.pvOrdCardsBound = true;

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-pv-ord-size]');
    if (!btn || btn.disabled) return;
    const card = btn.closest('[data-pv-ord-card]');
    if (!card) return;
    applyVariantSelection(card, btn);
  });
})();
